import moment from "moment";

export function isTimeGreaterThan(dateTime, time) {
  const givenDateTime = moment(dateTime?.toDate() || moment()).local();
  const serverTime = givenDateTime.format("HH:mm");

  const givenTime = moment(time, "h:mm A").format("HH:mm");

  return moment(givenTime, "HH:mm").isSameOrAfter(moment(serverTime, "HH:mm"));
}

export function isSameDay(dateString, dateFromTimestamp) {
  const dateToCompare = moment(dateString);
  return moment(dateFromTimestamp).isSame(dateToCompare, "day");
}
